import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState = false as boolean;

const slice = createSlice({
  name: 'tyroLibraryReady',
  initialState,
  reducers: {
    setTyroLibraryReady(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setTyroLibraryReady } = slice.actions;

export default slice.reducer;
